// PDF-only copies: keep original evidence untouched and flatten photos to RGB PNG
// so mobile PDF readers do not have to decode the original camera JPEG stream.
export async function preparePDFPhotos(job,loadEvidence){
  const cache=new Map();
  async function normalize(data){
    if(typeof data!=='string'||!/^data:image\//i.test(data))throw Error('Photo data is missing.');
    if(cache.has(data))return cache.get(data);
    const pending=new Promise((resolve,reject)=>{
      const image=new Image();
      image.onload=()=>{
        try{
          const w=image.naturalWidth||image.width,h=image.naturalHeight||image.height;
          if(!(w>0&&h>0))throw Error('Photo has no dimensions.');
          const scale=Math.min(1,2000/Math.max(w,h));
          const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(w*scale));canvas.height=Math.max(1,Math.round(h*scale));
          const ctx=canvas.getContext('2d',{alpha:false});if(!ctx)throw Error('Photo conversion is unavailable.');
          ctx.fillStyle='#fff';ctx.fillRect(0,0,canvas.width,canvas.height);ctx.drawImage(image,0,0,canvas.width,canvas.height);
          const png=canvas.toDataURL('image/png');if(!png.startsWith('data:image/png;base64,'))throw Error('Photo conversion failed.');
          resolve(png);
        }catch(error){reject(error);}
      };
      image.onerror=()=>reject(Error('Photo could not be decoded.'));
      image.src=data;
    });
    cache.set(data,pending);return pending;
  }
  async function photosFor(item,label){
    const photos=[];
    for(const [index,photo] of (item.photos||[]).entries()){
      let data;
      try{data=await normalize(photo.data);}
      catch(error){
        const original=item.evidence?.images?.[index]||item.evidence?.images?.[0];
        if(original&&loadEvidence&&!item.evidence?.annotation){
          try{data=await normalize(await loadEvidence(original));}catch{}
        }
        if(!data)throw Error(`A photo for ${label} could not be included. Open that finding and replace the photo, then export again.`);
      }
      photos.push({...photo,data});
    }
    return {...item,photos};
  }
  const findings=[],markers=[];
  for(const f of job.findings||[])findings.push(await photosFor(f,`finding ${f.cat}${f.letter}`));
  for(const m of job.markers||[])markers.push(await photosFor(m,`diagram pin ${m.label||''}`));
  return {...job,findings,markers};
}
export function addPDFPhoto(doc,photo,x,y,boxW,boxH,label){
  try{
    const properties=doc.getImageProperties(photo.data);
    if(!(properties.width>0&&properties.height>0))throw Error('Invalid photo dimensions');
    const scale=Math.min(boxW/properties.width,boxH/properties.height),width=properties.width*scale,height=properties.height*scale;
    doc.addImage(photo.data,properties.fileType,x+(boxW-width)/2,y+(boxH-height)/2,width,height,undefined,'FAST');
    doc.setDrawColor(200,210,220);doc.setLineWidth(0.5);doc.rect(x,y,boxW,boxH,'S');doc.setLineWidth(1);
  }catch(error){throw Error(`A photo for ${label} could not be embedded. Open that finding and replace the photo, then export again.`);}
}
